import {
  VStack,
  HStack,
  Heading,
  Text,
  StackProps,
  HeadingProps,
} from '@chakra-ui/react'
import React, { FC, ReactNode } from 'react'
import { Error, HandOk } from '../../icons'
import { useColor } from '../../theme'

enum Status {
  Error = 'error',
  Success = 'success'
}

interface IFeedbackContainerProps extends StackProps {
  title: string
  description?: ReactNode
  secondaryDescription?: ReactNode
  status?: Status
  headingProps?: HeadingProps
}

export const FeedbackContainer: FC<IFeedbackContainerProps> = ({
  title,
  description,
  secondaryDescription,
  status = Status.Success,
  headingProps,
  children,
  ...rest
}) => {
  const headingColor = useColor({ nuance: 5, palette: 'text' })
  const descriptionColor = useColor({ nuance: 1, palette: 'text' })
  const secondaryDescriptionColor = useColor({ nuance: 0, palette: 'text' })
  const infoIconColor = useColor({ palette: 'orange', nuance: 4 })

  return (
    <VStack align="center" maxWidth="xs" spacing={8} {...rest}>
      <VStack spacing={8}>
        <HStack w="full">
          <Heading
            color={headingColor}
            data-testid="feedback-container-title"
            size="lg"
            w="full"
            {...headingProps}>
            {title}
          </Heading>

          {status === Status.Error && (
            <Error
              color={infoIconColor}
              data-testid="feedback-container-error-icon"
              h={6}
              marginLeft="auto"
              w={6}
            />
          )}
          {status === Status.Success && (
            <HandOk
              data-testid="feedback-container-success-icon"
              h={20}
              w={20}
            />
          )}
        </HStack>

        <Text
          color={descriptionColor}
          data-testid="feedback-container-description"
          fontSize="md"
          w="full">
          {description}
        </Text>

        {secondaryDescription && (
          <Text
            color={secondaryDescriptionColor}
            data-testid="feedback-container-secondary-description"
            fontSize="sm">
            {secondaryDescription}
          </Text>
        )}
      </VStack>

      {children}
    </VStack>
  )
}
